import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScopeService {

  constructor(private http: HttpClient) { }

  scope: any[] = [];

  get Scope() {
    return this.scope;
  }
  set Scope(val) {
    this.scope = val;
  }

  public fetchScopes(fdClientId: number) {
    const params = new HttpParams().set('fdClientId', fdClientId.toString());
    return this.http.get('auth-scopes', { params }).pipe(
      tap((res: any) => {
        if (res.scopes) {
          res.scopes.push(
            {
              resource: "settings",
              actions: ["create", "read", "update", "delete"]
            },
            {
              resource: "profile",
              actions: ["create", "read", "update", "delete"]
            }
          );
        }
      })
    );
  }

  public resourceScope(resource) {
    return this.scope.filter(x => x.resource == resource);
  }

  public actionsScope(resource, action) {
    return this.scope.filter(x => x.resource == resource && x.actions.indexOf(action) > -1);
  }
}
